__webpack_require__.p = "https://assets-01.periodica.press/2a4494d-22398876147/";